import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { ServiceEventNames, ServiceActionTypes, HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import EahsForm from "../../../../components/EahsForm";
import FormSelect from "../../../../components/FormInputs/FormSelect";
import FormFileUpload from "../../../../components/FormInputs/FormFileUpload";

const HorseLeasingDocumentSection = ({
    getDocumentTypesByServiceIdData,
    leaseRequestData,
    currentLanguage,
    isReadOnly
}) => {
    const { translate } = useTranslate();
    const displayDocTypes = React.useMemo(() => {
        const types = (Array.isArray(getDocumentTypesByServiceIdData) ? getDocumentTypesByServiceIdData : []).map(a => ({
            label: currentLanguage === "en" ? a.nameEn : a.nameAr,
            value: a.id
        }));

        if (leaseRequestData?.documentTypeId && !types.find(t => t.value === leaseRequestData.documentTypeId)) {
            types.push({
                label: leaseRequestData.documentTypeName || "Selected Document",
                value: leaseRequestData.documentTypeId
            });
        }

        return types;
    }, [getDocumentTypesByServiceIdData, currentLanguage, leaseRequestData]);
    return (
        <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.UPLOAD_DOCUMENT, "Document")}>
            <FormSelect
                name={LeaseFieldNames.DOC_TYPE_DROP}
                label={translate(TranslationKeys.DOCUMENT_TYPE, "Document Type")}
                options={[{ label: translate(TranslationKeys.SERVICE_REQUEST_DOCUMENT_TYPE, "Supported Document (pdf,png)"), value: "" }, ...displayDocTypes]}
                placeholder={translate(TranslationKeys.DOCUMENT_TYPE, "Document Type")}
                disabled={isReadOnly}
                containerClass="col-md-6 col-sm-12 col-12 mb-form-group"
            />

            <div className="col-md-6 col-sm-12 col-12 mb-form-group">
                <FormFileUpload
                    name={LeaseFieldNames.ATTACHMENT_FILE}
                    label={translate(TranslationKeys.SERVICE_REQUEST_DOCUMENT_TYPE, "Supported Document (pdf,png)")}
                    accept="image/*,application/pdf"
                    isMulti={false}
                    disabled={isReadOnly}
                />
            </div>
        </EahsForm>
    );
};

export default HorseLeasingDocumentSection;
